<template>
  <div class="div1">
    <div v-if="title" class="title">{{title}}</div>
    <slot/>
  </div>
</template>

<script>
export default {
  props: ['title']

}
</script>

<style lang="scss" scoped>
div.div1{
  box-sizing: border-box;
  width: -webkit-fill-available;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 15px;
  min-height: fit-content;
  .title {
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    letter-spacing: 0.05em;
    color: var(--color-checked);
  }
}
</style>
